import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LegalEntityDetails } from '@app/models/project.models';
import { QualificationTabComponent } from '@app/pages/admin/entities/legal-entities/legal-entity-details/qualification-tab/qualification-tab.component';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-legal-qualification-summary-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ModalComponent,
    QualificationTabComponent,
  ],
  templateUrl: './legal-qualification-summary-dialog.component.html',
  styleUrl: './legal-qualification-summary-dialog.component.scss',
})
export class LegalQualificationSummaryDialogComponent {
  @Input() entity: LegalEntityDetails | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  protected handlePrimaryAction(): void {
    this.activeModal.dismiss();
  }

  protected handleSecondaryAction(): void {
    this.activeModal.close('requalify');
  }
}
